<template>
    <div class="wrapper tab-access">
        <header>
            <span class="new-headline-lg text-centered">Vitadio unterstützt Menschen mit Typ-2-Diabetes auf dem Weg zu besseren Blutzuckerwerten und einem gesünderen Gewicht.</span>
        </header>

        <div class="btn-group">
            <v-button label="Zugang freischalten" position="center" @onClick="$emit('answer')"></v-button>
        </div>

        <div class="access-proof">
            <figure class="access-person">
                <img
                    src="imgs/web/img_prof_schwarz.webp"
                    srcset="imgs/web/img_prof_schwarz.webp 1x, imgs/web/img_prof_schwarz@2x.webp 2x"
                    alt="Prof. Dr. med. Peter Schwarz"
                >
                <figcaption>
                    <strong class="text-blue new-text-sm">Prof. Dr. med. Peter Schwarz</strong>
                    <span class="text-color-default new-text-s">Leiter der klinischen Studien</span>
                </figcaption>
            </figure>

            <div class="access-proof-text">
                <strong class="new-text-lg">Wussten Sie…</strong>
                <p class="new-text-md text-color-default">die Wirksamkeit von Vitadio in mehreren wissenschaftlichen Studien nachgewiesen wurde?</p>
                <p class="new-text-md text-blue"><strong>Klinisch geprüft. Veröffentlicht in renommierten Fachzeitschriften.</strong></p>
            </div>
        </div>

        <div class="access-logos">
            <img src="imgs/web/logo_jmir.webp" width="150" alt="JMIR Publications">
            <img src="imgs/web/logo_nutrients_mdpi.webp" width="107" alt="Nutrients">
            <img src="imgs/web/logo_thieme.webp" width="86px" alt="Thieme">
        </div>
    </div>
</template>

<script>
    export default {}
</script>
